<template>
  <div id="accordion">
    <v-btn
      color="secondary"
      small
      class="mb-4 mr-2"
      @click="resetFilter"
    >Reset</v-btn>
    <v-btn
      color="primary"
      small
      class="mb-4"
      @click="applyFilter"
    >Apply filters</v-btn>
    <div class="accordion-filters" style="height: 75vh;">
      <dx-scroll-view
        width="100%"
        height="100%"
      >
        <div class="accordion-box">
          <div v-b-toggle.collapse-1 class="filter-accordion">Roles <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-1">
            <div class="collapse-container">
              <dx-tag-box
                v-if="roles"
                :data-source="roles"
                @value-changed="onValueChangedRoles"
                :value="filtersObject.selectedRoleItems"
                :search-enabled="true"
                display-expr="rolle"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-2 class="filter-accordion">Technology <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-2">
            <div class="collapse-container">
              <dx-tag-box
                v-if="brancheTypes"
                :data-source="brancheTypes"
                @value-changed="onValueChangedTechnology"
                :value="filtersObject.selectedTechnologyItems"
                :search-enabled="true"
                display-expr="brancheEn"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-3 class="filter-accordion">Startup Phase <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-3">
            <div class="collapse-container">
              <dx-tag-box
                v-if="startupPhaseTypes"
                :data-source="startupPhaseTypes"
                @value-changed="onValueChangedStartupPhase"
                :value="filtersObject.selectedStartupPhaseItems"
                :search-enabled="true"
                display-expr="startupphase"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-4 class="filter-accordion">University <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-4">
            <div class="collapse-container">
              <dx-tag-box
                v-if="universityTypes"
                :data-source="universityTypes"
                @value-changed="onValueChangedUniversity"
                :value="filtersObject.selectedUniversityItems"
                :search-enabled="true"
                display-expr="university"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-4b class="filter-accordion">Uni Spin Off <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-4b">
            <div class="collapse-container">
              <dx-tag-box
                v-if="universityTypes"
                :data-source="universityTypes"
                @value-changed="onValueChangedUniSpinOff"
                :value="filtersObject.selectedUniSpinOffItems"
                :search-enabled="true"
                display-expr="university"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-5 class="filter-accordion">Country B / P <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-5">
            <div class="collapse-container">
              <dx-check-box
                v-model="filtersObject.checkboxCountryB"
                text="Business"
                @value-changed="handleCountryBCheckboxChange"
                class="mr-3"
              />
              <dx-check-box
                v-model="filtersObject.checkboxCountryP"
                text="Personal"
                @value-changed="handleCountryPCheckboxChange"
              />
              <dx-tag-box
                v-if="countryTypes"
                :data-source="countryTypes"
                @value-changed="onValueChangedCountry"
                :value="filtersObject.selectedCountryItems"
                :search-enabled="true"
                display-expr="land"
                value-expr="field_001"
                class="mt-4"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-6 class="filter-accordion">Canton <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-6">
            <div class="collapse-container">
              <dx-tag-box
                v-if="cantonTypes"
                :data-source="cantonTypes"
                @value-changed="onValueChangedCanton"
                :value="filtersObject.selectedCantonItems"
                :search-enabled="true"
                display-expr="kantonEN"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-6a class="filter-accordion">Zip B / P <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-6a">
            <div class="collapse-container">
              <dx-check-box
                v-model="filtersObject.checkboxZipB"
                text="Business"
                @value-changed="handleZipBCheckboxChange"
                class="mr-3"
              />
              <dx-check-box
                v-model="filtersObject.checkboxZipP"
                text="Personal"
                @value-changed="handleZipPCheckboxChange"
              />
              <dx-tag-box
                @value-changed="onValueChangedZip"
                :value="filtersObject.selectedZipItems"
                :accept-custom-value="true"
                placeholder="Add Zip"
                noDataText="write a zip code and enter"
                class="mt-4"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-6b class="filter-accordion">City B / P <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-6b">
            <div class="collapse-container">
              <dx-check-box
                v-model="filtersObject.checkboxCityB"
                text="Business"
                @value-changed="handleCityBCheckboxChange"
                class="mr-3"
              />
              <dx-check-box
                v-model="filtersObject.checkboxCityP"
                text="Personal"
                @value-changed="handleCityPCheckboxChange"
              />
              <dx-tag-box
                @value-changed="onValueChangedCity"
                :value="filtersObject.selectedCityItems"
                :accept-custom-value="true"
                placeholder="Add City"
                noDataText="write a city and enter"
                class="mt-4"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-7a class="filter-accordion">Salutation <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-7a">
            <div class="collapse-container">
              <dx-tag-box
                v-if="salutationTypes"
                :data-source="salutationTypes"
                @value-changed="onValueChangedSalutation"
                :value="filtersObject.selectedSalutationItems"
                :search-enabled="true"
                :display-expr="customSalutationText"
                value-expr="ansprechzeile_id"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-7b class="filter-accordion">Awards <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-7b">
            <div class="collapse-container">
              <dx-tag-box
                v-if="awards"
                :data-source="awards"
                @value-changed="onValueChangedAwards"
                :value="filtersObject.selectedAwardsItems"
                display-expr="contest_release"
                value-expr="field_001"
                :search-enabled="true"
                :min-search-length="3"
                placeholder="Search... (min. 3 letters)"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-7c class="filter-accordion">Reporting Groups <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-7c">
            <div class="collapse-container">
              <dx-tag-box
                v-if="reportingGroups"
                :data-source="reportingGroups"
                @value-changed="onValueChangedReportingGroups"
                :value="filtersObject.selectedReportingGroupsItems"
                :search-enabled="true"
                display-expr="reportingGroups"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-7 class="filter-accordion">Legalform <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-7">
            <div class="collapse-container">
              <dx-tag-box
                v-if="rechtsformTypes"
                :data-source="rechtsformTypes"
                @value-changed="onValueChangedLegalForm"
                :value="filtersObject.selectedLegalformItems"
                :search-enabled="true"
                display-expr="rechtsform"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-8 class="filter-accordion">VK Case Status <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-8">
            <div class="collapse-container">
              <dx-tag-box
                v-if="vkCaseStatusTypes"
                :data-source="vkCaseStatusTypes"
                @value-changed="onValueChangedCaseStatus"
                :value="filtersObject.selectedCaseStatusItems"
                :search-enabled="true"
                display-expr="casestatus"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-9 class="filter-accordion">VK Technology <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-9">
            <div class="collapse-container">
              <dx-tag-box
                v-if="vekmisTechnology"
                :data-source="vekmisTechnology"
                @value-changed="onValueChangedVekmisTechnology"
                :value="filtersObject.selectedVekmisTechnologyItems"
                :search-enabled="true"
                display-expr="technologyEN"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-10 class="filter-accordion">Prio Vlab <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-10">
            <div class="collapse-container">
              <dx-tag-box
                v-if="priovlabTypes"
                :data-source="priovlabTypes"
                @value-changed="onValueChangedPrioVlabType"
                :value="filtersObject.selectedPrioVlabTypeItems"
                :search-enabled="true"
                display-expr="status"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-10b class="filter-accordion">Prio X-mas Vlab <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-10b">
            <div class="collapse-container">
              <dx-tag-box
                v-if="priovlabxmasTypes"
                :data-source="priovlabxmasTypes"
                @value-changed="onValueChangedPrioXmasType"
                :value="filtersObject.selectedPrioXmasTypeItems"
                :search-enabled="true"
                display-expr="statusxmas"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-11 class="filter-accordion">Interests verified <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-11">
            <div class="collapse-container">
              <span>Interests verified</span>
              <dx-tag-box
                v-if="addressInterests"
                :data-source="addressInterests"
                @value-changed="onValueChangedAddressInterests"
                :value="filtersObject.selectedaddressInterestsItems"
                :search-enabled="true"
                display-expr="interesse_en"
                value-expr="field_001"
                class="mt-1 mb-3"
              />
              <span>Interests Status (optional)</span>
              <dx-tag-box
                v-if="interestsStatus"
                :data-source="interestsStatus"
                @value-changed="onValueChangedInterestsStatus"
                :value="filtersObject.selectedInterestsStatusItems"
                :search-enabled="true"
                display-expr="status"
                value-expr="field_001"
                class="mt-1"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-12 class="filter-accordion">Event <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-12">
            <div class="collapse-container">
              <span>Event / Seminar</span>
              <dx-tag-box
                v-if="eventTitles"
                :data-source="eventTitles"
                @value-changed="onValueChangedEventTitles"
                :value="filtersObject.selectedEventTitlesItmes"
                :search-enabled="true"
                :min-search-length="3"
                placeholder="Search... (min. 3 letters)"
                class="mt-1 mb-3"
              />
              <span>Event Pool</span>
              <dx-tag-box
                v-if="eventPoolThemes"
                :data-source="eventPoolThemes"
                @value-changed="onValueChangedEventpoolThemes"
                :value="filtersObject.selectedEventpoolThemesItems"
                :search-enabled="true"
                :min-search-length="3"
                placeholder="Search... (min. 3 letters)"
                class="mt-1 mb-3"
              />
              <span>Affirmation<br></span>
              <dx-check-box
                v-model="filtersObject.checkboxAffirmation"
                text="Combined Event / Pool"
                @value-changed="handleAffirmationCheckboxChange"
                class="mr-3"
              />
              <dx-tag-box
                v-if="affirmationTypes"
                :data-source="affirmationTypes"
                @value-changed="onValueChangedAffirmation"
                :value="filtersObject.selectedAffirmation"
                :search-enabled="true"
                display-expr="affirmationEN"
                value-expr="field_001"
                placeholder="Select..."
                class="mt-1"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-12b class="filter-accordion">Event Sortdate<i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-12b">
            <div class="collapse-container">
              <dx-date-box
                :value="filtersObject.selectedEventDateFrom"
                @value-changed="onValueChangedEventDateFrom"
                placeholder="From"
                display-format="dd.MM.yyyy"
                picker-type="rollers"
                type="date"
                :show-clear-button="true"
              />
              <dx-date-box
                :value="filtersObject.selectedEventDateUntil"
                @value-changed="onValueChangedEventDateUntil"
                placeholder="Until"
                type="date"
                display-format="dd.MM.yyyy"
                picker-type="rollers"
                class="mt-2"
                :show-clear-button="true"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-13 class="filter-accordion">Sectors <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-13">
            <div class="collapse-container">
              <dx-tag-box
                v-if="sectors"
                :data-source="sectorsDataGrouped"
                @value-changed="onValueChangedEventSectors"
                :grouped="true"
                :value="filtersObject.selectedEventSectorsItems"
                :search-enabled="true"
                display-expr="kategorieDE"
                value-expr="field_001"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box" v-if="checkAdmin(currentUser.mitarbeiterId)">
          <div v-b-toggle.collapse-14 class="filter-accordion">Total Fundings<i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-14">
            <div class="collapse-container">
              <dx-number-box
                :value="filtersObject.selectedTotalFundingFrom"
                @value-changed="onValueChangedMoneyFrom"
                placeholder="From"
                format="#,##0.00"
                :show-clear-button="true"
              />
              <dx-number-box
                :value="filtersObject.selectedTotalFundingUntil"
                @value-changed="onValueChangedMoneyUntil"
                placeholder="Until"
                format="#,##0.00"
                class="mt-2"
                :show-clear-button="true"
              />
            </div>
          </b-collapse>
        </div>
        <div class="accordion-box">
          <div v-b-toggle.collapse-15 class="filter-accordion">Incorporation Date<i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-15">
            <div class="collapse-container">
              <dx-date-box
                :value="filtersObject.selectedDateFrom"
                @value-changed="onValueChangedIncorporationDateFrom"
                placeholder="From"
                display-format="dd.MM.yyyy"
                picker-type="rollers"
                type="date"
                :show-clear-button="true"
              />
              <dx-date-box
                :value="filtersObject.selectedDateUntil"
                @value-changed="onValueChangedIncorporationDateUntil"
                placeholder="Until"
                type="date"
                display-format="dd.MM.yyyy"
                picker-type="rollers"
                class="mt-2"
                :show-clear-button="true"
              />
            </div>
          </b-collapse>
        </div>
      </dx-scroll-view>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { DxTagBox } from 'devextreme-vue/tag-box'
  import { DxCheckBox } from 'devextreme-vue/check-box'
  import { DxNumberBox } from 'devextreme-vue/number-box'
  import DxDateBox from 'devextreme-vue/date-box'
  import DataSource from 'devextreme/data/data_source'
  import moment from 'moment'
  import { DxScrollView } from 'devextreme-vue/scroll-view'
  import { isAdmin } from '@/helpers/auth.js'

  const getInitialFilterData = () => ({
    selectedTechnologyItems: [],
    selectedStartupPhaseItems: [],
    selectedUniversityItems: [],
    selectedCountryItems: [],
    selectedCantonItems: [],
    selectedLegalformItems: [],
    selectedCaseStatusItems: [],
    selectedRoleItems: [],
    selectedVekmisTechnologyItems: [],
    selectedPrioVlabTypeItems: [],
    selectedPrioXmasTypeItems: [],
    selectedaddressInterestsItems: [],
    selectedEventTitlesItmes: [],
    selectedEventpoolThemesItems: [],
    selectedCityItems: [],
    selectedZipItems: [],
    selectedSalutationItems: [],
    selectedUniSpinOffItems: [],
    selectedAwardsItems: [],
    selectedEventSectorsItems: [],
    selectedReportingGroupsItems: [],
    selectedInterestsStatusItems: [],
    selectedAffirmation: [],
    selectedDateFrom: null,
    selectedDateUntil: null,
    selectedEventDateFrom: null,
    selectedEventDateUntil: null,
    selectedTotalFundingFrom: null,
    selectedTotalFundingUntil: null,
    checkboxCountryB: true,
    checkboxCountryP: true,
    checkboxZipB: true,
    checkboxZipP: true,
    checkboxCityB: true,
    checkboxCityP: true,
    checkboxAffirmation: true
  })

  export default {
    components: {
      DxTagBox,
      DxCheckBox,
      DxDateBox,
      DxNumberBox,
      DxScrollView
    },
    props: {
    },
    data () {
      return {
        hasError: false,
        multiple: true,
        collapsible: true,
        animationDuration: 300,
        resetValue: false,
        sectorsLoaded: false,
        filtersObject: {
          ...getInitialFilterData()
        },
        sectorsDataGrouped: undefined,
        rules: /[02-9]/
      }
    },
    created () {
      this.getBasicValues('basicValues/GET_BRANCHE_TYPES', this.brancheTypes)
      this.getBasicValues('basicValues/GET_STARTUPHASE_TYPES', this.startupPhaseTypes)
      this.getBasicValues('basicValues/GET_UNIVERSITY_TYPES', this.universityTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_CANTON_TYPES', this.cantonTypes)
      this.getBasicValues('basicValues/GET_RECHTSFORM_TYPES', this.rechtsformTypes)
      this.getBasicValues('basicValues/GET_VKCASESTATUS_TYPES', this.vkCaseStatusTypes)
      this.getBasicValues('basicValues/GET_ROLES', this.roles)
      this.getBasicValues('basicValues/GET_VEKMIS_TECHNOLOGY', this.vekmisTechnology)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_PRIOVLABXMAS_TYPES', this.priovlabxmasTypes)
      this.getBasicValues('basicValues/GET_INTERESTS', this.addressInterests)
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_AWARDS', this.awards)
      this.getBasicValues('basicValues/GET_SECTORS', this.sectors)
      this.getBasicValues('basicValues/GET_REPORTING_GROUPS', this.reportingGroups)
      this.getBasicValues('basicValues/GET_AFFIRMATION_TYPES', this.affirmationTypes)
      this.onGetEventTitles()
      this.onGetEventpoolThemes()
      this.onGetInterestsStatus()

      if (this.sectors.length > 0) {
        this.sectorsDataGrouped = new DataSource({
          store: this.sectors,
          key: 'field_001',
          group: 'pROFILHauptcategory.hauptkategorieDE'
        })
      }
      // save empty filter-values for save query process
      this.$store.commit('recherche/SET_SAVE_QUERY_ALL_FILTERS', this.filtersObject)
    },
    methods: {
      resetFilter () {
        this.$store.commit('recherche/SET_COMPLETE_CUSTOM_FILTER', null)
        this.$emit('send-custom-filters')
        Object.assign(this.$data.filtersObject, getInitialFilterData())
      },
      applyFilter () {
        let completeFilter = ''
        this.$store.commit('recherche/SET_COMPLETE_CUSTOM_FILTER', null)
        this.$store.commit('recherche/SET_SAVE_QUERY_ALL_FILTERS', this.filtersObject)
        for (const filter in this.selectedFilters) {
          if (this.selectedFilters[filter] !== '') {
            completeFilter += completeFilter === '' ? `(${this.selectedFilters[filter]})` : ` AND (${this.selectedFilters[filter]})`
          }
        }
        if (completeFilter !== '') {
          this.$store.commit('recherche/SET_COMPLETE_CUSTOM_FILTER', completeFilter)
        } else {
          this.$store.commit('recherche/SET_COMPLETE_CUSTOM_FILTER', null)
        }
        this.$emit('send-custom-filters')
      },
      setLoadedFilter (allFilters) {
        Object.assign(this.$data.filtersObject, allFilters)
        setTimeout(() => {
          this.applyFilter()
        }, 1000)
      },
      // handler for the B & P Checkboxes
      handleCountryBCheckboxChange (e) {
        if (e.value === false) {
          this.filtersObject.checkboxCountryP = true
        }
        const countryValue = { value: this.filtersObject.selectedCountryItems }
        this.onValueChangedCountry(countryValue)
      },
      handleCountryPCheckboxChange (e) {
        if (e.value === false) {
          this.filtersObject.checkboxCountryB = true
        }
        const countryValue = { value: this.filtersObject.selectedCountryItems }
        this.onValueChangedCountry(countryValue)
      },
      handleZipBCheckboxChange (e) {
        if (e.value === false) {
          this.filtersObject.checkboxZipP = true
        }
        const zipValue = { value: this.filtersObject.selectedZipItems }
        this.onValueChangedZip(zipValue)
      },
      handleZipPCheckboxChange (e) {
        if (e.value === false) {
          this.filtersObject.checkboxZipB = true
        }
        const zipValue = { value: this.filtersObject.selectedZipItems }
        this.onValueChangedZip(zipValue)
      },
      handleCityBCheckboxChange (e) {
        if (e.value === false) {
          this.filtersObject.checkboxCityP = true
        }
        const cityValue = { value: this.filtersObject.selectedCityItems }
        this.onValueChangedCity(cityValue)
      },
      handleCityPCheckboxChange (e) {
        if (e.value === false) {
          this.filtersObject.checkboxCityB = true
        }
        const cityValue = { value: this.filtersObject.selectedCityItems }
        this.onValueChangedCity(cityValue)
      },
      handleAffirmationCheckboxChange (e) {
        this.filtersObject.checkboxAffirmation = e.value
        this.handleCombinedAffirmationFilter()
      },
      handleCombinedAffirmationFilter () {
        if (this.filtersObject.checkboxAffirmation === true) {
          this.onValueChangedCombinedAffirmation()
        } else {
          this.$store.commit('rechercheFilters/SET_FILTER_COMBINED_EVENT_AFFIRMATION', '')
          this.$store.commit('rechercheFilters/SET_FILTER_COMBINED_THEME_AFFIRMATION', '')
        }
      },
      // handler for the tag boxes
      onValueChangedTechnology (e) {
        this.filtersObject.selectedTechnologyItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_TECHNOLOGY', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'technologyId')
        this.$store.commit('rechercheFilters/SET_FILTER_TECHNOLOGY', returnedFilters)
      },
      onValueChangedStartupPhase (e) {
        this.filtersObject.selectedStartupPhaseItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_STARTUPPHASE', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'startupPhaseId')
        this.$store.commit('rechercheFilters/SET_FILTER_STARTUPPHASE', returnedFilters)
      },
      onValueChangedUniversity (e) {
        this.filtersObject.selectedUniversityItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_UNIVERSITY', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'universityId')
        this.$store.commit('rechercheFilters/SET_FILTER_UNIVERSITY', returnedFilters)
      },
      onValueChangedUniSpinOff (e) {
        this.filtersObject.selectedUniSpinOffItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_UNI_SPIN_OFF', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'unispinoffId')
        this.$store.commit('rechercheFilters/SET_FILTER_UNI_SPIN_OFF', returnedFilters)
      },
      onValueChangedCountry (e) {
        this.filtersObject.selectedCountryItems = e.value
        if (e.value.length) {
          this.$store.commit('rechercheFilters/SET_FILTER_COUNTRY_B_P', '')
          const returnedBFilters = this.preparingFilterStructure(e.value, 'countryBId')
          const returnedPFilters = this.preparingFilterStructure(e.value, 'countryPId')
          let completeFilter = ''
          if (this.checkboxCountryB && this.checkboxCountryP) {
            completeFilter = returnedBFilters + ' OR ' + returnedPFilters
          } else if (this.checkboxCountryB && !this.checkboxCountryP) {
            completeFilter = returnedBFilters
          } else {
            completeFilter = returnedPFilters
          }
          this.$store.commit('rechercheFilters/SET_FILTER_COUNTRY_B_P', completeFilter)
        } else {
          this.$store.commit('rechercheFilters/SET_FILTER_COUNTRY_B_P', '')
        }
      },
      onValueChangedCanton (e) {
        this.filtersObject.selectedCantonItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_CANTON', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'kantonId')
        this.$store.commit('rechercheFilters/SET_FILTER_CANTON', returnedFilters)
      },
      onValueChangedLegalForm (e) {
        this.filtersObject.selectedLegalformItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_LEGALFORM', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'legalFormId')
        this.$store.commit('rechercheFilters/SET_FILTER_LEGALFORM', returnedFilters)
      },
      onValueChangedCaseStatus (e) {
        this.filtersObject.selectedCaseStatusItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_CASESTATUS', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'vkCaseStatus')
        this.$store.commit('rechercheFilters/SET_FILTER_CASESTATUS', returnedFilters)
      },
      onValueChangedRoles (e) {
        this.filtersObject.selectedRoleItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_ROLES', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'roles')
        this.$store.commit('rechercheFilters/SET_FILTER_ROLES', returnedFilters)
      },
      onValueChangedVekmisTechnology (e) {
        this.filtersObject.selectedVekmisTechnologyItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_VEKMIS_TECHNOLOGY', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'vekmisTechnologyEN')
        this.$store.commit('rechercheFilters/SET_FILTER_VEKMIS_TECHNOLOGY', returnedFilters)
      },
      onValueChangedPrioVlabType (e) {
        this.filtersObject.selectedPrioVlabTypeItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_PRIO_VLAB_TYPE', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'priovlabId')
        this.$store.commit('rechercheFilters/SET_FILTER_PRIO_VLAB_TYPE', returnedFilters)
      },
      onValueChangedPrioXmasType (e) {
        this.filtersObject.selectedPrioXmasTypeItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_PRIO_XMAS_TYPE', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'prioXMasId')
        this.$store.commit('rechercheFilters/SET_FILTER_PRIO_XMAS_TYPE', returnedFilters)
      },
      onValueChangedAddressInterests (e) {
        this.filtersObject.selectedaddressInterestsItems = e.value
        this.interestsVerfifiedFilter()
      },
      onValueChangedInterestsStatus (e) {
        this.filtersObject.selectedInterestsStatusItems = e.value
        this.interestsVerfifiedFilter()
      },
      interestsVerfifiedFilter () {
        this.$store.commit('rechercheFilters/SET_FILTER_ADDRESS_INTERESTS', '')
        if (this.filtersObject.selectedaddressInterestsItems.length > 0 && this.filtersObject.selectedInterestsStatusItems.length === 0) {
          const returnedFilters = this.preparingFilterStructure(this.filtersObject.selectedaddressInterestsItems, 'interestsPositive')
          this.$store.commit('rechercheFilters/SET_FILTER_ADDRESS_INTERESTS', returnedFilters)
        } else if (this.filtersObject.selectedaddressInterestsItems.length > 0 && this.filtersObject.selectedInterestsStatusItems.length > 0) {
          const statusInterests = {
            interestsYes1: '',
            interestsNo2: '',
            interestsMaybe3: '',
            interestsSold4: '',
            interestsHot5: ''
          }
          const statusItems = this.filtersObject.selectedInterestsStatusItems
          for (const item in statusItems) {
            const status = statusItems[item]
            switch (status) {
            case 1:
              statusInterests.interestsYes1 = this.preparingFilterStructure(this.filtersObject.selectedaddressInterestsItems, 'interestsYes1')
              break
            case 2:
              statusInterests.interestsNo2 = this.preparingFilterStructure(this.filtersObject.selectedaddressInterestsItems, 'interestsNo2')
              break
            case 3:
              statusInterests.interestsMaybe3 = this.preparingFilterStructure(this.filtersObject.selectedaddressInterestsItems, 'interestsMaybe3')
              break
            case 4:
              statusInterests.interestsSold4 = this.preparingFilterStructure(this.filtersObject.selectedaddressInterestsItems, 'interestsSold4')
              break
            case 5:
              statusInterests.interestsHot5 = this.preparingFilterStructure(this.filtersObject.selectedaddressInterestsItems, 'interestsHot5')
              break
            }
          }
          let filterStructure = ''
          for (const el in statusInterests) {
            if (statusInterests[el] !== '') {
              if (filterStructure === '') {
                filterStructure += `(${statusInterests[el]})`
              } else {
                filterStructure += ` OR (${statusInterests[el]})`
              }
            }
          }
          this.$store.commit('rechercheFilters/SET_FILTER_ADDRESS_INTERESTS', filterStructure)
        } else {
          this.$store.commit('rechercheFilters/SET_FILTER_ADDRESS_INTERESTS', '')
        }
      },
      onValueChangedCombinedAffirmation () {
        this.$store.commit('rechercheFilters/SET_FILTER_COMBINED_EVENT_AFFIRMATION', '')
        this.$store.commit('rechercheFilters/SET_FILTER_COMBINED_THEME_AFFIRMATION', '')
        // affirmation can be used as a combined filter with event list title and theme EN together.
        // that's why there is a field with both together. in this function they are built together to create the filter.
        if (this.filtersObject.selectedAffirmation.length) {
          const titleAffirmationList = []
          const themeAffirmationList = []
          if (this.filtersObject.selectedEventTitlesItmes.length) {
            for (const el in this.filtersObject.selectedAffirmation) {
              for (const elx in this.filtersObject.selectedEventTitlesItmes) {
                titleAffirmationList.push(this.filtersObject.selectedEventTitlesItmes[elx] + this.filtersObject.selectedAffirmation[el])
              }
            }
          }
          if (this.filtersObject.selectedEventpoolThemesItems.length) {
            for (const el in this.filtersObject.selectedAffirmation) {
              for (const elx in this.filtersObject.selectedEventpoolThemesItems) {
                themeAffirmationList.push(this.filtersObject.selectedEventpoolThemesItems[elx] + this.filtersObject.selectedAffirmation[el])
              }
            }
          }
          if (titleAffirmationList.length) {
            const returnedFilters = this.preparingFilterStructureStrings(titleAffirmationList, 'crmBestellungen.eventListTitleAffirmation')
            this.$store.commit('rechercheFilters/SET_FILTER_COMBINED_EVENT_AFFIRMATION', returnedFilters)
          }
          if (themeAffirmationList.length) {
            const returnedFilters = this.preparingFilterStructureStrings(themeAffirmationList, 'crmBestellungen.themeAffirmation')
            this.$store.commit('rechercheFilters/SET_FILTER_COMBINED_THEME_AFFIRMATION', returnedFilters)
          }
        }
      },
      onValueChangedEventTitles (e) {
        this.filtersObject.selectedEventTitlesItmes = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_EVENT_TITLES', '')
        const returnedFilters = this.preparingFilterStructureStrings(e.value, 'eventlistTitleEN')
        this.$store.commit('rechercheFilters/SET_FILTER_EVENT_TITLES', returnedFilters)
        if (this.filtersObject.selectedAffirmation.length) {
          this.handleCombinedAffirmationFilter()
        }
      },
      onValueChangedEventpoolThemes (e) {
        this.filtersObject.selectedEventpoolThemesItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_EVENTPOOL_THEMES', '')
        const returnedFilters = this.preparingFilterStructureStrings(e.value, 'eventpoolThemaEN')
        this.$store.commit('rechercheFilters/SET_FILTER_EVENTPOOL_THEMES', returnedFilters)
        if (this.filtersObject.selectedAffirmation.length) {
          this.handleCombinedAffirmationFilter()
        }
      },
      onValueChangedAffirmation (e) {
        this.filtersObject.selectedAffirmation = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_AFFIRMATION', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'crmBestellungen.eventSignupAffirmIDId')
        this.$store.commit('rechercheFilters/SET_FILTER_AFFIRMATION', returnedFilters)
        if (this.filtersObject.selectedAffirmation.length) {
          this.handleCombinedAffirmationFilter()
        }
      },
      onValueChangedReportingGroups (e) {
        this.filtersObject.selectedReportingGroupsItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_REPORTING_GROUPS', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'reportingGroups')
        this.$store.commit('rechercheFilters/SET_FILTER_REPORTING_GROUPS', returnedFilters)
      },
      onValueChangedCity (e) {
        this.filtersObject.selectedCityItems = e.value
        if (e.value.length) {
          this.$store.commit('rechercheFilters/SET_FILTER_CITY_B_P', '')
          const returnedBFilters = this.preparingFilterStructureStrings(e.value, 'cityB')
          const returnedPFilters = this.preparingFilterStructureStrings(e.value, 'cityP')
          let completeFilter = ''
          if (this.checkboxCityB && this.checkboxCityP) {
            completeFilter = returnedBFilters + ' OR ' + returnedPFilters
          } else if (this.checkboxCityB && !this.checkboxCityP) {
            completeFilter = returnedBFilters
          } else {
            completeFilter = returnedPFilters
          }
          this.$store.commit('rechercheFilters/SET_FILTER_CITY_B_P', completeFilter)
        } else {
          this.$store.commit('rechercheFilters/SET_FILTER_CITY_B_P', '')
        }
      },
      onValueChangedZip (e) {
        this.filtersObject.selectedZipItems = e.value
        if (e.value.length) {
          this.$store.commit('rechercheFilters/SET_FILTER_ZIP_B_P', '')
          const returnedBFilters = this.preparingFilterStructureStrings(e.value, 'zipB')
          const returnedPFilters = this.preparingFilterStructureStrings(e.value, 'zipP')
          let completeFilter = ''
          if (this.checkboxZipB && this.checkboxZipP) {
            completeFilter = returnedBFilters + ' OR ' + returnedPFilters
          } else if (this.checkboxZipB && !this.checkboxZipP) {
            completeFilter = returnedBFilters
          } else {
            completeFilter = returnedPFilters
          }
          this.$store.commit('rechercheFilters/SET_FILTER_ZIP_B_P', completeFilter)
        } else {
          this.$store.commit('rechercheFilters/SET_FILTER_ZIP_B_P', '')
        }
      },
      onValueChangedSalutation (e) {
        this.filtersObject.selectedSalutationItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_SALUTATION', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'salutationId')
        this.$store.commit('rechercheFilters/SET_FILTER_SALUTATION', returnedFilters)
      },
      onValueChangedEventSectors (e) {
        this.filtersObject.selectedEventSectorsItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_SECTORS', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'sectors')
        this.$store.commit('rechercheFilters/SET_FILTER_SECTORS', returnedFilters)
      },
      onValueChangedAwards (e) {
        this.filtersObject.selectedAwardsItems = e.value
        this.$store.commit('rechercheFilters/SET_FILTER_AWARDS', '')
        const returnedFilters = this.preparingFilterStructure(e.value, 'contests')
        this.$store.commit('rechercheFilters/SET_FILTER_AWARDS', returnedFilters)
      },
      onValueChangedIncorporationDateFrom (e) {
        this.filtersObject.selectedDateFrom = e.value
        this.incorporationDateFilter()
      },
      onValueChangedIncorporationDateUntil (e) {
        this.filtersObject.selectedDateUntil = e.value
        this.incorporationDateFilter()
      },
      incorporationDateFilter () {
        const fromDate = this.filtersObject.selectedDateFrom !== null ? moment(this.filtersObject.selectedDateFrom).unix() : null
        const untilDate = this.filtersObject.selectedDateUntil !== null ? moment(this.filtersObject.selectedDateUntil).unix() : null
        this.$store.commit('rechercheFilters/SET_FILTER_INCORPORATION_DATE', '')
        const returnedFilters = this.preparingFilterStructureFromUntil(fromDate, untilDate, 'timeStampIncorporationDate')
        this.$store.commit('rechercheFilters/SET_FILTER_INCORPORATION_DATE', returnedFilters)
      },
      onValueChangedEventDateFrom (e) {
        this.filtersObject.selectedEventDateFrom = e.value
        this.eventDateFilter()
      },
      onValueChangedEventDateUntil (e) {
        this.filtersObject.selectedEventDateUntil = e.value
        this.eventDateFilter()
      },
      eventDateFilter () {
        const fromDate = this.filtersObject.selectedEventDateFrom !== null ? moment(this.filtersObject.selectedEventDateFrom).unix() : null
        const untilDate = this.filtersObject.selectedEventDateUntil !== null ? moment(this.filtersObject.selectedEventDateUntil).unix() : null
        this.$store.commit('rechercheFilters/SET_FILTER_EVENT_SORTDATE', '')
        const returnedFilters = this.preparingFilterStructureFromUntil(fromDate, untilDate, 'eventlistSortDate')
        this.$store.commit('rechercheFilters/SET_FILTER_EVENT_SORTDATE', returnedFilters)
      },
      onValueChangedMoneyFrom (e) {
        this.filtersObject.selectedTotalFundingFrom = e.value
        this.totalFundingFilter()
      },
      onValueChangedMoneyUntil (e) {
        this.filtersObject.selectedTotalFundingUntil = e.value
        this.totalFundingFilter()
      },
      totalFundingFilter () {
        const fromTotalFunding = this.filtersObject.selectedTotalFundingFrom !== null ? this.filtersObject.selectedTotalFundingFrom : null
        const untilTotalFunding = this.filtersObject.selectedTotalFundingUntil !== null ? this.filtersObject.selectedTotalFundingUntil : null
        this.$store.commit('rechercheFilters/SET_FILTER_TOTAL_FUNDING', '')
        const returnedFilters = this.preparingFilterStructureFromUntil(fromTotalFunding, untilTotalFunding, 'totalFundings')
        this.$store.commit('rechercheFilters/SET_FILTER_TOTAL_FUNDING', returnedFilters)
      },
      preparingFilterStructureFromUntil (from, until, filterField) {
        let filterStructure = ''
        if (from !== null && until !== null) {
          filterStructure += `${filterField} >= ${from} AND ${filterField} <= ${until}`
        } else if (from === null && until !== null) {
          filterStructure += `${filterField} <= ${until}`
        } else if (from !== null && until === null) {
          filterStructure += `${filterField} >= ${from}`
        } else {
          filterStructure = ''
        }
        return filterStructure
      },
      preparingFilterStructureStrings (selectedFilters, filterField) {
        let filterStructure = ''
        for (const el in selectedFilters) {
          if (filterStructure === '') {
            filterStructure += `${filterField} = '${selectedFilters[el].replace(/'/g, "\\'")}'`
          } else {
            filterStructure += ` OR ${filterField} = '${selectedFilters[el].replace(/'/g, "\\'")}'`
          }
        }
        return filterStructure
      },
      preparingFilterStructure (selectedFilters, filterField) {
        let filterStructure = ''
        for (const el in selectedFilters) {
          if (filterStructure === '') {
            filterStructure += `${filterField} = ${selectedFilters[el]}`
          } else {
            filterStructure += ` OR ${filterField} = ${selectedFilters[el]}`
          }
        }
        return filterStructure
      },
      customSalutationText (data) {
        if (data) {
          return `${data.ansprechzeile} ${data.geschlecht_PopupExtension ? data.geschlecht_PopupExtension : ''}`
        } else {
        }
      },
      async getBasicValues (storePath, storeValue) {
        this.hasError = false
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            console.error(err)
          }
        }
      },
      async onGetEventTitles () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('rechercheFilters/GET_EVENT_EVENTLIST_TITLE')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          console.error(err)
        }
      },
      async onGetEventpoolThemes () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('rechercheFilters/GET_EVENTPOOL_THEMES')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          console.error(err)
        }
      },
      async onGetInterestsStatus () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('rechercheFilters/GET_INTERESTS_STATUS')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          console.error(err)
        }
      },
      checkAdmin (id) {
        return isAdmin(id)
      }
    },
    computed: {
      ...mapGetters({
        brancheTypes: 'basicValues/BRANCHE_TYPES',
        startupPhaseTypes: 'basicValues/STARTUPHASE_TYPES',
        universityTypes: 'basicValues/UNIVERSITY_TYPES',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        cantonTypes: 'basicValues/CANTON_TYPES',
        rechtsformTypes: 'basicValues/RECHTSFORM_TYPES',
        vkCaseStatusTypes: 'basicValues/VKCASESTATUS_TYPES',
        roles: 'basicValues/ROLES',
        vekmisTechnology: 'basicValues/VEKMIS_TECHNOLOGY',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        priovlabxmasTypes: 'basicValues/PRIOVLABXMAS_TYPES',
        addressInterests: 'basicValues/INTERESTS',
        eventTitles: 'rechercheFilters/EVENTTITLES',
        eventPoolThemes: 'rechercheFilters/EVENTPOOL_THEMES',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        awards: 'basicValues/AWARDS',
        sectors: 'basicValues/SECTORS',
        reportingGroups: 'basicValues/REPORTING_GROUPS',
        interestsStatus: 'rechercheFilters/INTERESTS_STATUS',
        affirmationTypes: 'basicValues/AFFIRMATION_TYPES'
      }),
      ...mapState({
        currentUser: state => state.user.currentUser,
        selectedFilters: state => state.rechercheFilters.filters
      })
    },
    watch: {
      sectors: function (newSector, oldSector) {
        if (newSector.length > 0) {
          this.sectorsDataGrouped = new DataSource({
            store: this.sectors,
            key: 'field_001',
            group: 'pROFILHauptcategory.hauptkategorieDE'
          })
        }
      }
    }
  }
</script>
<style lang="scss">
#accordion p {
  margin: 0;
}

.accordion-box {
  &.disabled {
    pointer-events: none;
    color: #c4c4c4;
  }
}

</style>
